import { array } from 'prop-types';
import React, { useEffect, useState } from 'react';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const GridLines = () => {
    const [showGridLines, setShowGridLines] = useState(false);

    const storageKey = 'bva:grid-lines';

    const toggleGridlines = setShowGridLines.bind(null, (cV) => {
        localStorage.setItem(storageKey, String(!cV));
        return !cV;
    });

    useEffect(() => {
        window.toggleGridlines = toggleGridlines;

        const inStorage = localStorage.getItem(storageKey);

        if (inStorage) {
            setShowGridLines(inStorage === 'true');
        }

        const toggleGridWithKeys = (event) => {
            // CTRL + Shift + 4
            if (event.ctrlKey && event.shiftKey && Number(event.key) === 4) {
                toggleGridlines();
            }
        };

        window.addEventListener('keydown',toggleGridWithKeys);

        return () => {
            window.removeEventListener('keydown', toggleGridWithKeys);
        };
    }, []);

    if (!showGridLines) {
        return null;
    }

    return (
        <div
            className='fixed w-full inset-0 pointer-events-none overflow-hidden'
            style={{
                zIndex: '9999'
            }}>
            <div className='layout-container h-screen'>
                <div className='flex h-full gap-1'>
                    {Array(9).fill(null).map((_, i) => {
                        return (
                            <div
                                className={`flex-grow
                                ${i >= 3 ? 'max-sm:hidden' : ''}
                                ${i >= 5 ? 'sm:max-md:hidden' : ''}
                                ${i >= 7 ? 'md:max-lg:hidden' : ''}
                                `}
                                key={i}>
                                <div
                                    className='h-full'
                                    style={{
                                        borderColor: '#cc6461bd',
                                        backgroundColor: '#cc646129',
                                        borderStyle: 'solid',
                                        borderTopWidth: '0',
                                        borderBottomWidth: '0',
                                        borderLeftWidth: '1px',
                                        borderRightWidth: '1px',
                                    }}>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default GridLines;
